// modules/clientes/routes/ClientesRoutes.jsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import ClientesPage from "../pages/ClientesPage";
import { ClienteProvider } from "../context/ClienteContext";
import ClienteDetallePage from "../pages/ClienteDetallePage";


const ClientesRoutes = () => {
  return (
    <ClienteProvider>
      <Routes>
        <Route path="" element={<ClientesPage />} />
        <Route path=":cod_cliente" element={<ClienteDetallePage />} />
      </Routes>
    </ClienteProvider>
  );
};

export default ClientesRoutes;